
//<Tabs/>dom监控扩展类
class Tabs {
  private config: any = {};
  constructor(config: { selector: string, extFieldName?: string }) {
    this.config = config;
  }
  getExt() {
    let el = document.querySelector(this.config.selector);
    let tabKey;
    if (el) {
      let activeTab = el.querySelector('.winitd-tabs-tab-active');
      if (activeTab) {
        tabKey = activeTab.getAttribute('data-node-key');
      }
    }
    if (!tabKey) return null;
    return {
      [this.config.extFieldName || 'tabKey']: tabKey,
    };
  }
  private createObserver() {
  }
  start() {

  };
  stop() {
  }
}

export default Tabs;
